module.exports = __webpack_public_path__ + "img/sel_Dalian-.7046b278.png";